<template>
    <div class="mod-config">
      <el-dialog title="供应商选择" width="80%" :visible.sync="viewData.visible" append-to-body>

        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px" placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询</el-button>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  highlight-current-row  border :header-cell-style="{background:'#f5f5f5'}" @current-change="currentChange" >
            <el-table-column header-align="center" label="序号" align="center" width="55">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="venderLogin" header-align="center" align="left" label="供应商账号" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderLogin }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                <template slot-scope="scope">
                  {{ scope.row.venderName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="left" label="供应商简称" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAdd" header-align="center" align="left" label="供应商地址" width="250">
                <template slot-scope="scope">
                    {{ scope.row.venderAdd }}
                </template>
            </el-table-column>
            <el-table-column prop="venderContacts" header-align="center" align="left" label="联系人" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderContacts }}
                </template>
            </el-table-column>
            <el-table-column prop="venderMail" header-align="center" align="right" label="邮箱" width="200">
                <template slot-scope="scope">
                    {{ scope.row.venderMail }}
                </template>
            </el-table-column>
            <el-table-column prop="venderTel" header-align="center" align="right" label="联系电话" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderTel }}
                </template>
            </el-table-column>
       </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
          <!-- 询价中 -->
            <el-button size="small" type="primary" @click="confirm()">
                确认
            </el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
    import {selectSupplierPage} from '@/controller/supplier'
    import {DIALOG_CLOSED_TYPE} from "@/utils/const";

    export default {
        data() {
            return {
                synSAPLoading:false,
                qualifiedInviteLoading:false,
                dataForm: {
                    key: ''
                },
                activeName:'',
                activeName2:'',
                gpsdialog: false,
                gpsdialog2: false,
                flag: '',
                gpsStatusvalflag: '',
                radio: '',
                radioSelect: '',  //选中的数据赋值给它
                temp: {},
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                viewData: {
                  visible: false,
                  width: "",
                },

                venderName: '',
                checkCreated: true,
                checkInvited: true,
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 415) + "px"
                    }
                },

                venderCode : '',
                enterpriseName : '',

                options: [
                    {
                        value: '1',
                        label: '正常'
                    }, 
                    {
                        value: '0',
                        label: '冻结'
                    }
                ],
                options2:[
                    {
                        supplierLevel: '1',
                        label: '合格'
                    }
                ],
                value: '',
                supplierId:'',
                supplierLevel:'1',
                currentRow: {},
            }
        },

        components: {
        },

        activated() {
            this.flag = this.$route.params.gpsStatusvalflag
            if (this.flag === "1") {
                this.checkCreated = true
                this.checkInvited = false
            }
            if (this.$route.query && this.$route.query.gpsStatusval && this.$route.query.gpsStatusval.length > 0) {
                this.gpsStatusval = encodeURI(JSON.stringify(this.$route.query.gpsStatusval))
            } else {
                this.gpsStatusval = ''
            }
            this.getDataList()
        },

        methods: {
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectSupplierPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName,
                    'freezingThaw' : this.value,
                    'supplierLevel' : this.supplierLevel
                }).then(data => {
                    if (data && data.code === '00') {
                        console.log('获取到数据')
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },
            rowClassName({
                             row,
                             rowIndex
                         }) {
                //把每一行的索引放进row.id
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
          open() {
            this.viewData.visible = true;
            this.getDataList();
          },
          currentChange(currentRow) {
            this.currentRow = currentRow;
          },
          onClosed(params) {
            console.log(params);
            return;
          },
          close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
              return;
            }
            if (this.multiple) {
              this.onClosed({
                option,
                sender: this,
                data: this.userList,
              });
            } else {
              this.onClosed({
                option,
                sender: this,
                data: this.currentRow,
              });
            }
            this.viewData.visible = false;
          },
          confirm() {
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
          },

        }
    }
</script>

<style lang="scss">
    .button-danger { color: #F56C6C; }
    .fr { float: right; }
</style>